export const latest_editor_version = '1.1.3'

export const block_versions = {
  checkout_button: '1.1',
  listing_breadcrumb: '1.1',
}
